/**
 * EL TOPE DE GRASA DEL POSTENTRENO (Jesús, «El postentreno, cerrado», 27-09, paso 3): la
 * bebida vegetal, «hasta llegar a los cuatro gramos de grasa como máximo», y «al llegar al
 * tope no deja subir más». Es tope, no objetivo: puede no poner bebida.
 *
 * Solo se sugería con el tope; con los botones +/- o tecleando la cantidad se pasaba de largo.
 * Aquí solo se frena la BEBIDA VEGETAL (categoría 24): la leche entera del «económico» se pasa
 * de los 4 g a propósito («es la excepción de la grasa»), y no se toca.
 *
 * La grasa por ml sale del punto de partida del alimento (lib/escalarMacros), no del último
 * valor redondeado: con eso el «+» de uno en uno no llegaba nunca al tope.
 */
import { porGramo } from './escalarMacros';

export const TOPE_GRASA_POST = 4;

const categorias = (f) => String(f?.categorias || '').split('|').map((c) => c.trim());
export const esBebidaVegetal = (f) => categorias(f).some((c) => c === '24' || c.startsWith('24.'));

const grasa = (f) => Number(f?.macros_efectivos?.G || 0);

/**
 * La cantidad a la que se queda la bebida `index` si se pide `nueva`. Devuelve
 * { cantidad, frenada }. Si la comida ya pasa del tope sin la bebida, la bebida no sube,
 * pero tampoco se le quita lo que tenía. Por unidades, a unidades enteras.
 */
export const TOPE_LECHE_ENTERA_POST = 250;
export const esLecheEntera = (f) => String(f?.nombre || '').trim().toLowerCase().startsWith('leche entera');
export const AVISO_TOPE_LECHE_ENTERA = 'La leche entera en el postentreno llega hasta 250 g como máximo.';

export const cantidadConTope = (foods, index, nueva) => {
    const f = foods[index];
    // LA LECHE ENTERA, SU EXCEPCIÓN (Jesús, 27-09 23:02): «tiene un tope de 250 g, da igual los
    // macros; es una excepción porque no debería dejar meterla porque se pasa de grasa».
    // La grasa no la frena; los 250 g, siempre.
    if (f && esLecheEntera(f)) {
        return nueva > TOPE_LECHE_ENTERA_POST
            ? { cantidad: TOPE_LECHE_ENTERA_POST, frenada: true, aviso: AVISO_TOPE_LECHE_ENTERA }
            : { cantidad: nueva, frenada: false };
    }
    if (!f || !esBebidaVegetal(f)) return { cantidad: nueva, frenada: false };
    const actual = Number(f.cantidad_g ?? f.cantidad ?? 0);
    const gPorGramo = porGramo(f, 'G');
    if (gPorGramo <= 0 || nueva <= actual) return { cantidad: nueva, frenada: false };
    const resto = foods.reduce((s, x, i) => (i === index ? s : s + grasa(x)), 0);
    // Una milésima de holgura: el tope es «hasta 4 g», y 4,0 cabe.
    let maxima = (TOPE_GRASA_POST - resto) / gPorGramo + 1e-6;
    const unidad = (f.por_unidad ?? f.unidades) ? Number(f.peso_unidad || f.racion || 0) : 0;
    maxima = unidad > 0 ? Math.floor(maxima / unidad) * unidad : Math.floor(maxima);
    maxima = Math.max(actual, maxima);
    return nueva > maxima ? { cantidad: maxima, frenada: true } : { cantidad: nueva, frenada: false };
};

export const AVISO_TOPE_GRASA_POST = 'Has llegado a los 4 g de grasa del postentreno.';
